import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../../api/config";
import EmpLayout from "./emp_layout";
import './css/shortlist.css';

export function Shortlist() {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Fetch data from C# Backend
    const fetchShortlist = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(`${API_ENDPOINTS.EMPSHORTLIST}`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (response.ok) {
                const result = await response.json();
                setData(result);
            }
        } catch (error) {
            console.error("Error fetching shortlist:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchShortlist(); }, []);

    // Handle Remove Action
    const handleRemove = async (id) => {
        if (!window.confirm("Move this candidate back to the general applicant pool?")) return;
        
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(`${API_ENDPOINTS.EMPSHORTLIST}/${id}`, {
                method: 'DELETE',
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (response.ok) {
                // Refresh data
                fetchShortlist();
            }
        } catch (error) {
            console.error("Error removing candidate:", error);
        }
    };

    if (loading) return <EmpLayout title="Loading..." titleEm="Shortlist"><div>Loading candidates...</div></EmpLayout>;

    return (
        <EmpLayout title="Candidate" titleEm="Shortlist">
            {/* Stats Row */}
            <div className="sl-stats">
                {[
                    ["Shortlisted", data?.shortlistedCount || 0],
                    ["Interviews Scheduled", data?.interviewsScheduled || 0],
                    ["Offers Sent", data?.offersSent || 0]
                ].map(([k, v]) => (
                    <div key={k} className="sl-stat">
                        <div className="sl-stat-n">{v}</div>
                        <div className="sl-stat-l">{k}</div>
                    </div>
                ))}
            </div>

            <div className="emp-section-hdr" style={{ marginBottom: "1rem" }}>
                <div className="emp-section-title">Top <em>candidates</em></div>
            </div>

            <div className="sl-list">
                {data?.candidates && data.candidates.length > 0 ? (
                    data.candidates.map((c, i) => (
                        <div key={c.id} className="sl-card">
                            <div className={`sl-rank${i < 3 ? " top" : ""}`}>{i + 1}</div>
                            <div className="sl-avatar">{c.initials}</div>
                            <div className="sl-info">
                                <div className="sl-name">{c.name}</div>
                                <div className="sl-spec">{c.specialization}</div>
                                <div className="sl-for-role">For: {c.role}</div>
                            </div>
                            <div className="sl-actions">
                                <button className="sl-btn primary" onClick={() => navigate(`/employer/candidate/${c.id}`)}>
                                    View Profile
                                </button>
                                <button className="sl-btn danger" onClick={() => handleRemove(c.id)}>
                                    Remove
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="emd-listing-card emd-empty-container">
                        <div className="emd-empty-content">
                            <div className="emd-empty-icon">⭐</div>
                            <h3 className="emd-empty-title">Your shortlist is empty</h3>
                            <p className="emd-empty-text">
                                Go to your applicants and shortlist the best talent to see them here.
                            </p>
                            <button className="sl-btn primary" onClick={() => navigate("/employer/applicants")}>
                                View Applicants
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </EmpLayout>
    );
}